export default "__VITE_ASSET__lzNo4hVP__"